import { Injectable } from '@angular/core';
import { Http, Response, Headers, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { CONFIGURATION } from '../app.config';

@Injectable()
export class GranularLevelService {

  private _AuthUrl = CONFIGURATION.baseAuthURL;
  private apiurl = CONFIGURATION.baseServiceUrl + 'granular-level/';

  constructor(private _http: Http) { }

  getReferenceData(data:any) {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.post(`${this.apiurl}reference-data`,data, { headers: headers })
      .map((response: Response) => response.json())
  }
  
  getReportData(data:any) {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.post(`${this.apiurl}summary`, data, { headers: headers })
      .map((response: Response) => response.json())
  }

  getDetailSummary(data:any) {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.post(`${this.apiurl}detail-summary`, data, { headers: headers })
      .map((response: Response) => response.json())
  }

  excelDownload(data: any): any {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.post(`${this.apiurl}summary-excel-download`, data, { headers: headers, responseType: ResponseContentType.Blob }).map(
        (res) => {
            const a = document.createElement('a');
            document.body.appendChild(a);
            const blob = new Blob([res.blob()], { type: 'application/zip' });
            const downloadUrl = URL.createObjectURL(blob);
            window.open(downloadUrl);
        })
}
}



// WEBPACK FOOTER //
// ./src/app/granular-level/granular-level.service.ts